export default "__VITE_ASSET__7IimX9fe__"